const alertDialog = {
    successTitle: "نجاح",
    successText: "تمت العملية بنجاح.",
    failTitle: "فشل",
    failText: "حدث خطأ ما أثناء تنفيذ العملية.",
    ok: "موافق",
};
const statuses = {
    available: "متاح",
    onModeration: "قيد المراجعة",
    declined: "مرفوض",
    soldOut: "مباع",
    unpublished: "غير منشور",
    distress: "بيع بخصم",
};
const floorsList = {
    low: "منخفض",
    medium: "متوسط",
    high: "مرتفع",
    null: "",
};
const paymentMethods = {
    bank_check: "شيك بنكي", // I18N
    credit_debit_card: "بطاقة مدين / ائتمان",
    cash: "نقدي",
    bank_transfer: "تحويل بنكي",
    crypto: "عملة رقمية",
};
const heightsList = {
    Simplex: "سيمبلكس",
    Duplex: "دوبلكس",
    Triplex: "تريبلكس",
    Quadruplex: "كوادروبلكس",
    "Five Floors": "خمسة طوابق",
    "Six Floors": "ستة طوابق",
    Loft: "لوفت",
    simplex: "سيمبلكس",
    duplex: "دوبلكس",
    triplex: "تريبلكس",
    quadruplex: "كوادروبلكس",
    "five floors": "خمسة طوابق",
    "six floors": "ستة طوابق",
    loft: "لوفت",
};
const units = {
    units_one: "{{count}} وحدة",
    units_two: "{{count}} وحدات",
    units_few: "{{count}} وحدات",
    units_many: "{{count}} وحدات",
    units_other: "{{count}} وحدات",
};
const projects = {
    projects_one: "{{ count }} مشروع",
    projects_two: "{{ count }} مشاريع",
    projects_few: "{{ count }} مشاريع",
    projects_many: "{{ count }} مشاريع",
    projects_other: "{{ count }} مشاريع",
};
const roles = {
    broker: "مستخدم",
    head_of_sales_department: "مسؤول",
    admin: "المسؤول الأعلى",
};
const passwordRecoveryModal = {
    header: "استعادة كلمة المرور",
    body: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    forgotSubmited: "لقد أرسلنا لك رسالة، اتبع الرابط الموجود فيها لإنشاء كلمة مرور جديدة.",
    continue: "متابعة",
    ok: "موافق",
};
const changePasswordModal = {
    title: "تغيير كلمة المرور",
    body: "أنشئ كلمة مرور جديدة. يجب أن تتكون من 8 أحرف على الأقل وتحتوي على حرف كبير وصغير ورقم ورمز.",
    uppercaseAndLowercaseLetterTitle: "يجب أن تحتوي كلمة المرور على حرف صغير وحرف كبير واحد على الأقل.",
    oneDigitTitle: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
    specialSymbolTitle: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
    minimumLengthTitle: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل.",
    oldPassword: {
        title: "كلمة المرور الحالية",
        placeholder: "أدخل كلمة المرور الحالية",
    },
    newPassword: {
        title: "كلمة المرور الجديدة",
        placeholder: "أدخل كلمة المرور الجديدة",
    },
    newPasswordConfirm: {
        title: "تأكيد كلمة المرور",
        placeholder: "تأكيد كلمة المرور الجديدة",
    },
    forgotButton: "نسيت كلمة المرور",
    passwordSubmited: {
        header: "لديك الآن كلمة مرور جديدة!",
        body: "تم إنشاء كلمة المرور الجديدة بنجاح ويمكنك الآن استخدامها لتسجيل الدخول إلى Geniemap.",
    },
    continue: "متابعة",
    ok: "موافق",
};
const editImage = {
    title: "تحرير الصورة",
    reset: "إعادة تعيين",
    apply: "تطبيق",
};
const profileForm = {
    generalSubheader: "معلومات عامة",
    name: "الاسم الأول اسم العائلة",
    emailTooltip: "إذا كنت تريد تحديث البريد الإلكتروني، يرجى سؤال المسؤول.",
    phone: "رقم الهاتف",
    socialSubheader: "شبكات التواصل الاجتماعي",
    socialNetworksTooltip: "حقول اختيارية. ستظهر كجهات اتصال إضافية في الكتالوج الخاص بك.",
};
const catalogSettingsModal = {
    title: "تخصيص الكتالوج",
    titleMobile: "إعداد الكتالوج",
    tab1: "عام",
    tab2: "شرائح إضافية",
    themeColor: "لون السمة",
    language: "اللغة",
    measures: "وحدات القياس",
    currency: "العملة",
    additionalCurrency: "عملة إضافية",
    additionalCurrencyHint: "يعرض الأسعار بعملتين مختلفتين.",
    noAdditionalCurrency: "لا توجد عملة إضافية",
    socialNetworks: "عرض شبكات التواصل الاجتماعي الخاصة بي",
    unitsWithLayouts: "وحدات مع تخطيطات",
    hideUnitsNumbers: "إخفاء أرقام الوحدات",
    fullUnitsList: "قائمة الوحدات الكاملة",
    areaSlide: "موقع المشروع",
    hideDeveloper: "إخفاء المطور",
    hideDeveloperHint: "يزيل اسم المطور من عنوان المشروع ووصفه.",
    developerSlide: "وصف المطور",
    customSlide: "شريحة مخصصة",
    customSlideTitle: "عنوان الشريحة",
    customSlideText: "النص على الشريحة",
    customSlideHint: "يظهر في نهاية الكتالوج. \nيمكنك إضافة صورة ونص إلى الشريحة.",
    requiredField: "حقل مطلوب",
    reset: "إعادة تعيين إلى الوضع الافتراضي",
    resetMobile: "إعادة تعيين",
    save: "حفظ",
    selectImage: 'اختر صورة',
};
const filters = {
    title: "فلاتر",
    clear: "مسح",
    reset: "إعادة تعيين",
    tabs: {
        location: {
            title: "الموقع",
            search: "البحث عن موقع",
            region: {
                AE: "إمارة",
                default: "منطقة",
            },
            regionNoData: {
                AE: "لا توجد إمارات تطابق بحثك",
                default: "لا توجد مناطق تطابق بحثك",
            },
            districts: "منطقة",
            districtsNoData: "لا توجد مناطق في الإمارات المحددة",
            districtsRegionsNoData: "لا توجد مناطق في المناطق المحددة",
        },
        company: {
            title: "شركة",
            search: "البحث عن شركة",
            noResultsFound: "لم يتم العثور على نتائج",
            tryDifferentSearchOptions: "حاول استخدام خيارات بحث مختلفة",
            addToFavoriteError: "خطأ في إضافة إلى المفضلة",
            favourites: "الشركات المفضلة",
            tabs: {
                all: "الجميع",
                developers: "المطورون",
                agencies: "وكالات",
            },
        },
        moreFilters: {
            title: "الفلاتر الرئيسية",
            statisticsTitle: "المزيد من الفلاتر",
            showMe: {
                title: "فلاتر إضافية",
                favourites: "المفضلة",
                preLaunch: "قبل الإطلاق",
                soldOut: "مباع",
                myAgencyUnits: "وحدات وكالتي",
                developerStock: "مخزون المطور",
                resale: "إعادة بيع",
                distress: "بيع بخصم",
            },
            availability: {
                title: "حالة المشروع",
            },
            handover: {
                title: "حالة الاكتمال",
                from: "الاكتمال من",
                to: "الاكتمال إلى",
                offPlan: "على الخريطة",
                ready: "جاهز",
                year: "سنة",
                quarter: "ربع سنة",
                unselected: "غير محدد",
                preset_one: "<{{count}} سنة",
                preset_two: "<{{count}} سنوات",
                preset_few: "<{{count}} سنوات",
                preset_many: "<{{count}} سنوات",
                preset_other: "<{{count}} سنوات",
            },
            price: {
                title: "السعر",
                from: "من",
                to: "إلى",
            },
            pricePerSquare: {
                title: "السعر لكل {{squareMeasurement}}",
                from: "من",
                to: "إلى",
            },
            size: {
                title: "الحجم",
                from: "من",
                to: "إلى",
            },
            height: {
                title: "ارتفاع الوحدة",
            },
            ownershipType: {
                title: "نوع الملكية",
                allTypes: "جميع الأنواع",
                leasehold: "حق انتفاع",
                freehold: "ملكية حرة",
            },
            layout: {
                title: "تخطيط",
            },
            unitType: {
                title: "نوع الوحدة",
            },
            furnishing: {
                title: "التأثيث",
            },
            unitFeatures: {
                title: "ميزات الوحدة",
            },
            serviceCharge: {
                title: {
                    TH: "صندوق التمويل/رسوم الصيانة",
                    default: "رسوم الخدمة",
                },
                from: "من",
                to: "إلى",
            },
            paymentPlans: {
                title: "خطط الدفع",
                subtitle: "دفعة أولى",
                secondSubtitle: "دفعة أولى بـ {{currency}}",
                from: "من",
                to: "إلى",
                postHandover: "بعد التسليم",
            },
            forAdmins: {
                title: "للمسؤولين",
                allUnits: "جميع الوحدات",
                unitsWithLayouts: "وحدات مع تخطيطات فقط",
                unitsWithoutLayouts: "وحدات بدون تخطيطات فقط",
                responsibleEmployee: "الموظف المسؤول",
                selectEmployee: "اختر الموظف",
                unitsRequireVerification: "الوحدات التي تتطلب التحقق",
            },
            hints: {
                favorite: "المشاريع التي أضفتها إلى المفضلة",
                ourUnits: "وحدات إعادة البيع المدرجة من قبل شركتك",
                serviceCharge: "رسوم الخدمة السنوية",
                postHandover: "يشمل المدفوعات بعد التسليم.",
            },
        },
    },
};
const measures = {
    language: "اللغة",
    russianLanguage: "الروسية",
    englishLanguage: "الإنجليزية",
    arabicLanguage: 'العربية', // I18N
    currency: "العملة",
    measures: "وحدات القياس",
};
const countries = {
    searchPlaceholder: "البحث عن دولة", // I18N
    modalTitle: "الدول", // I18N
    planTitle: "{{available}}/{{total}} دولة", // I18N
    planSubtitle: "متاح في باقتك.", // I18N
    planHint: "اطلب من مديرك المزيد من الصلاحيات.", // I18N
    subtitles: {
        projects1000: "1000+ مشروع", // I18N
        projects500: "500+ مشروع", // I18N
        projectsCount: "{{count}}+ مشروع", // I18N
        readyToConnect: "جاهز للاتصال", // I18N
        comingSoon: "قريباً", // I18N
    },
    footer: "اكتشف خيارات عقارية متنوعة حول العالم ←", // I18N
    noResults: "لم يتم العثور على دول", // I18N
    changeCountryError: {
        title: "تعذر تبديل الدولة", // I18N
        description: "يرجى المحاولة مرة أخرى لاحقاً", // I18N
    },
};
const login = {
    welcome: "مرحبًا 👋",
    description: "ابدأ في تتبع أفضل العقارات في الإمارات",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login: "تسجيل الدخول",
    forgotPassword: "نسيت كلمة المرور؟",
    registrationRequest: "طلب التسجيل",
    passwordRecovery: {
        header: "استعادة كلمة المرور",
        body: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
        forgotSubmited: "لقد أرسلنا لك رسالة، اتبع الرابط الموجود فيها لإنشاء كلمة مرور جديدة.",
    },
    continue: "متابعة",
    ok: "موافق",
};
const autocomplete = {
    searchPlaceholder: "بحث",
    noMatch: "لا يوجد تطابق",
};
const noSelected = "غير محدد"; // I18N
export { alertDialog, statuses, floorsList, paymentMethods, heightsList, units, projects, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, noSelected, };
